import { Box, Item } from 'devextreme-react/box';
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import { ValidationSummary } from "devextreme-react/validation-summary";
import {
	ActualShipDatePanel,
	ExitButton,
	PurchaseOrderAddNoteButton,
	PurchaseOrderCards,
	PurchaseOrderFilesButton,
	PurchaseOrderNotesPanel,
	PurchaseOrderPage,
	PurchaseOrderProgress,
	PurchaseOrderProgressStep,
	PurchaseOrderShipProducts,
	SaveButton
} from '../../../features/distributor/purchase-order';
import '../../../css/order.scss';

export default function PurchaseOrderShipPage() {

	return (

		<PurchaseOrderPage>

			<PurchaseOrderCards />

			<PurchaseOrderProgress />

			<ValidationSummary />

			<Toolbar className='button-toolbar'>
				<ToolbarItem location={'before'}>
					<SaveButton step={PurchaseOrderProgressStep.Ship} />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<PurchaseOrderFilesButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<ExitButton />
				</ToolbarItem>
				<ToolbarItem location={'after'}>
					<PurchaseOrderAddNoteButton />
				</ToolbarItem>
			</Toolbar>

			<Box>
				<Item ratio={1}>
					<ActualShipDatePanel />
				</Item>
				<Item ratio={1}>
					<PurchaseOrderNotesPanel height={200} />
				</Item>
			</Box>

			<PurchaseOrderShipProducts />

		</PurchaseOrderPage>
	)
}
